import React from 'react';
import moment from 'moment'
import { Table, Input, Button, Icon, Alert, Modal } from 'antd';

import '../App.css';
import config from '.././config.json';
import $ from 'jquery';
import LoginForm from '../LoginForm.js';
import Admin from '../Admin/Admin';

class RegisterClasses extends React.Component {
    constructor(props) {
        super(props);
        this.temp = '';
        this.todayD = new Date();
        this.today = this.todayD.toISOString().substring(0, 10);
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/registration/getcategory`,
        })
            .done((data) => {
                this.setState({filterCategory: data });
            })
            .fail((jqXhr) => {
                console.log('failed to get category');
            });
    }


    state = {
        fullData: [],
        targetKeys: [],
        data:[],
        data2: [],
        sortedInfo: null,
        filterCategory: [],
        selectedRowKeys: [],
        login: true,
    }

    componentDidMount() {
        this.getMock();
        this.setState({
            selectedRowKeys: this.props.renderData
        });
        LoginForm.ValidateServerToken(
            () => { this.setState({ login: false }) }, ); //login
    }

 

 
    // Handles Changes in table
    handleChangeSort = (pagination, filters, sorter) => {
        this.setState({
            sortedInfo: sorter,
        });
    }


    //Generate the data
    getMock = () => {

        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/registration/getclasses`,
        })
            .done((data) => {
                this.setState({ targetKeys: data });
                this.setState({ data: data });
            })
            .fail((jqXhr) => {
                console.log('failed to get data');
            });
    }

    // Handles change for table
    handleChange = (targetKeys) => {
        this.setState({ targetKeys });
    }

    renderFooter = () => {
        return (
            <Button
                size="small"
                style={{ float: 'right', margin: 5 }}
                onClick={this.getMock}
            >
                reload
      </Button>
        );
    }

    updateData(system, search) {
        let data = this.state.data;
        if (system !== 'All') {
            //console.log(system);
            data = data.filter(function (item) {
                if (item.SystemName == system) {
                    return true;
                }
            });
        }

        if (search !== undefined || search !== '') {
            const reg = new RegExp(search, 'gi');

            data = data.filter(function (item) {
                if (item.Name.match(reg)) {
                    return true;
                }
            });
        }

        var todayF = new Date();
        // todayF.setDate(todayF.getDate() - 1)

        var todayFil = todayF.toISOString().substring(0, 10);
        
        // Only show future classes
        if(!Admin.isAdminLoggedIn()){

            data = data.filter(function (item) {
                if (item.AvailableDate >= todayFil) {
                    return true;
                }
            });
        }
        if (Admin.isAdminLoggedIn()) {
            data = data.sort(function (a, b) {
                return new Date(b.StartDate) - new Date(a.StartDate);
            });
        }
        return data;
    }

    // Function used for comparisions in sort
    compareByChar(a, b) { if (a > b) { return -1; } if (a < b) { return 1; } return 0; }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys });
        this.setState({ data2: selectedRows });
        this.props.getData(selectedRows,selectedRowKeys);

    }

    convertClassModeIDtoName = (id) => {
        return id === 1 ? 'Online' : (id === 2 ? 'In Person' : 'Hybrid');
    }

    isClassFull = (record) => {
        //console.log(record);
        if (record.OnlineCapacity === 'N/A') { // not a hybrid course, do the old way
            return record.Capacity === 'Capacity Full';
        } else { // hybrid course so check both.
            return (record.Capacity === 'Capacity Full' && record.OnlineCapacity === 'Capacity Full');
        }
    }

    render() {
        console.log(this.state)
        const selectionType = this.props.multiStudent ? "radio": "checkbox";
        const { selectedRowKeys } = this.state;
        // Used to select rows
        var todayF = new Date();
        var todayFil = todayF.toISOString().substring(0, 10);
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            getCheckboxProps: record => ({
                //disabled: (record.Waitlist <= 0 && record.Capacity === 'Capacity Full'),
                disabled: (this.isClassFull(record) || (this.state.login == false && record.isIndefinite == "False" && new Date(record.StartDate).getTime() <= todayF.getTime())) // Column configuration not to be checked

            }),
        };

        let { sortedInfo } = this.state;
        sortedInfo = sortedInfo || {};
        const columns = [{
            title: 'Class',
            dataIndex: 'Name',
            key: 'Name',
            sorter: (a, b) => this.compareByChar(a.Name, b.Name),
            sortOrder: sortedInfo.columnKey === 'Name' && sortedInfo.order,
        }, {
            title: 'Category',
            dataIndex: 'CategoryName',
            key: 'CategoryName',
            filters: this.state.filterCategory,
            onFilter: (value, record) => record.CategoryName.indexOf(value) === 0,
            sorter: (a, b) => this.compareByChar(a.CategoryName, b.CategoryName),
            sortOrder: sortedInfo.columnKey === 'CategoryName' && sortedInfo.order,
        },
        {
            title: 'Class Mode',
            dataIndex: 'ClassModeID',
            key: 'ClassModeID',
            render: (text, record, index) => {
                return (
                    <span>
                        {this.convertClassModeIDtoName(text)}
                    </span>
                )
            }
        },
        {
            title: 'Starts',
            dataIndex: 'StartDate',
            key: 'StartDate',
            render: (text, record, index) => {
                if (record.SystemName == "ESCC") {
                    return (
                        <span>
                            {moment(text).format('l')}
                        </span>
                    );

                }
                else {
                    if(record.IsIndefinite == "Indefinite"){
                        return(
                        <span>
                            This class is open indefinitely.
                        </span>
                        )
                    }
                    return (
                        <span>
                            {moment(text).format('l [at] h:mm A z')}
                        </span>
                    );
                }
            },
            filters: [{
                text: 'All Classes',
                value: '1/1/1',
            }, {
                text: 'Future Classes',
                value: this.today,
            }
            ],
            filterMultiple: false,
            onFilter: (value, record) => this.compareByChar(record.StartDate, value) <= 0,
            sorter: (a, b) => this.compareByChar(a.StartDate, b.StartDate),
            sortOrder: sortedInfo.columnKey === 'StartDate' && sortedInfo.order,
            }, {
                title: 'Ends',
                dataIndex: 'EndDate',
                key: 'EndDate',
                render: (text, record, index) => {
                    console.log(record)
                    if(record.IsIndefinite == "Indefinite"){
                        return(
                        <span>
                            N/A
                        </span>
                        )
                    }
                    return (
                        <span>
                            {moment(text).format('l')}
                        </span>
                    );
                },
        },
            {
                title: 'Cost',
                dataIndex: 'Cost',
                key: 'Cost',
            },
            {
                title: 'Venue',
                dataIndex: 'Venue',
                key: 'Venue',
                render: (text, record, index) => {
                    var url = record.VenueURL;
                    if (url === '') {
                        return (
                            <span>
                                {text}
                            </span>
                        );
                    }

                    else {
                        if (!/^(?:f|ht)tps?\:\/\//.test(record.VenueURL)) {
                            url = 'http://' + record.VenueURL;
                        }
                        return (
                            <span>
                                <a target="_blank" href={url}> {text}</a>
                            </span>
                        );

                    }

                }      
            },
            {
                title: 'Address',
                dataIndex: 'Address',
                key: 'Address',
            },
            {
                title: 'Seats Available',
                dataIndex: 'Capacity',
                key: 'Capacity', //change to render?
                render: (text, record, index) => {
                    if(record.IsIndefinite == "Indefinite"){
                        return(
                        <span>
                            N/A
                        </span>
                        )
                    }
                    if (record.OnlineCapacity === 'N/A') {
                        return (<span>{text}</span>);
                    } else {
                        return (<span>In Person: {record.Capacity} <br/> Online: {record.OnlineCapacity}</span>)
                    }
                }
            },
            {
                title: 'Comments',
                dataIndex: 'Comments',
                render: (text, record, index) => {
                    if (record.Comments) {
                        return (
                            <div className="editable-row-operations">
                                <span>
                                    <a onClick={() => Modal.info({
                                        title: record.Comments, onOk() { },
                                    })}>More Info</a>
                                </span>
                            </div>
                        );
                    }
                }
            }];

        return (
            <div>
                <Table rowKey="Id" rowSelection={{type: selectionType, ...rowSelection}} 
                    columns={columns} dataSource={this.updateData(this.props.systemFilter, this.props.searchName)} 
                    size="small" onChange={this.handleChangeSort} bordered  
                />
                <hr/>
                <Alert
                    message="Selected Courses"
                    description=""
                    type="info"
                    showIcon
                />
            </div>
        );
    }
}
export default RegisterClasses;


// WEBPACK FOOTER //
// ./src/Registration/RegisterClasses.js